export default class LanguageManager {
   static LOCAL_STORAGE_KEY = 'preferredLanguage';

   constructor(languageSelectWrapperSelector) {

      // MEMO:debug用に言語を強制的に変更するときに使用
      // Object.defineProperty(navigator, "language", {
      //    get: () => "en-US" // 任意の言語コードに変更
      // });

      // 言語選択の親要素を取得
      this.languageSelectWrappers = Array.from(document.querySelectorAll(languageSelectWrapperSelector));
      this.handleLanguageChangeBound = this.handleLanguageChange.bind(this);
   }

   // 言語設定の初期化
   init() {
      console.log("LanguageManager:init fired");

      if (this.languageSelectWrappers.length === 0) return;

      this.languageSelectWrappers.forEach((wrapper) => {
         const select = wrapper.querySelector("select");
         if (!select) return;

         // イベントリスナーの設定
         this.removeChangeListeners(select);
         select.addEventListener('change', this.handleLanguageChangeBound);

         // ローカルストレージにない場合のみvalueセット後にchangeイベントを発火させる
         const localStorageLanguage = this.getLocalStorageLanguage();
         if (localStorageLanguage) {
            select.value = localStorageLanguage;
         } else {
            select.value = this.getBrowserLanguage();
            select.dispatchEvent(new Event('change'));
         }
      });
   }

   removeChangeListeners(select) {
      select.removeEventListener('change', this.handleLanguageChangeBound);
   }

   // 言語選択変更時の処理
   handleLanguageChange(event) {
      console.log("Language change event:", event);
      const selectedLanguage = event.target.value;
      if (selectedLanguage) {
         try {
            // 言語設定は必須機能として常に保存
            localStorage.setItem(LanguageManager.LOCAL_STORAGE_KEY, selectedLanguage);
            console.log(`Language updated to: ${selectedLanguage}`);

            this.handleLanguageRedirect(selectedLanguage);
         } catch (error) {
            console.error("Failed to save preferred language:", error);
            alert("Could not save your language preference. Please try again.");
         }
      } else {
         alert("Please select a language.");
      }
   }

   getLocalStorageLanguage() {
      return localStorage.getItem(LanguageManager.LOCAL_STORAGE_KEY);
   }

   // ブラウザの言語設定を確認（日本語以外は英語として扱う）
   getBrowserLanguage() {
      const browserLanguage = navigator.language || navigator.userLanguage;
      if (browserLanguage && !browserLanguage.startsWith("ja")) {
         console.log(`非日本語のブラウザ言語検出: ${browserLanguage}`);
         return 'en';
      } else {
         console.log(`日本語のブラウザ言語検出: ${browserLanguage}`);
         return 'ja';
      }
   }

   // 言語リダイレクト処理
   handleLanguageRedirect(selectedLanguage) {
      const currentUrl = new URL(window.location.href);
      if (selectedLanguage === 'en' && !currentUrl.pathname.startsWith("/en/")) {
         currentUrl.pathname = `/en${currentUrl.pathname}`;
      } else if (selectedLanguage === 'ja' && currentUrl.pathname.startsWith("/en/")) {
         // currentUrl.pathname = currentUrl.pathname.replace(/^\/en/, '');
         currentUrl.pathname = currentUrl.pathname.replace(/^\/en(\/|$)/, '/');
      } else {
         console.log("言語リダイレクトは不要です。");
         return;
      }
      console.log(`リダイレクト先: ${currentUrl.href}`);
      window.location.replace(currentUrl.href);
   }
}

